/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';

import Fade from 'react-reveal/Fade';
import Button from 'elements/Button';

// Function to convert service title to URL slug
const getServiceSlug = (title) => {
  const slugMap = {
    'Mobile Development': 'mobile-development',
    'Web Development': 'web-development',
    'UI/UX Design': 'ui-ux-design',
    'Product Engineering': 'product-engineering',
    'Cloud Managed Services': 'cloud-managed-services',
    'Technology Migration': 'technology-migration',
    'Internet Of Things': 'internet-of-things',
    'Deployment & Support': 'deployment-support',
    'Maintenance & Scaling': 'maintenance-scaling',
    'Data Engineering': 'data-engineering',
    'Architecture Design': 'architecture-design',
  };
  return slugMap[title] || title.toLowerCase().replace(/\s+/g, '-').replace(/&/g, '');
};

export default function Service({ data }) {
  return (
    <div className="bg-gray-50">
      <div className="container mx-auto pt-24 pb-32">
        <Fade bottom>
          <h1 className="text-5xl lg:text-6xl text-theme-blue text-center font-bold mb-4">Services</h1>

          <p className="font-light text-lg lg:text-xl text-gray-600 text-center mb-16 max-w-3xl mx-auto">
            We work as your tech partners enabling digital transformation, process
            re-engineering, and building solutions that scale as per business needs using
            ultra-modern technologies and AI enablement.
          </p>
        </Fade>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 px-4 sm:px-10 gap-6 lg:gap-8">
          {
                        data.map((item, index) => {
                          const serviceSlug = getServiceSlug(item.title);
                          return (
                            <Fade bottom delay={300 * index} key={item.title}>
                              <Button
                                type="link"
                                href={`/service/${serviceSlug}`}
                                className="block h-full"
                              >
                                <div className="bg-white group rounded-2xl shadow-lg border border-gray-100 transform transition-all duration-500 hover:scale-105 hover:shadow-2xl overflow-hidden h-full flex flex-col cursor-pointer">
                                  <div className="overflow-hidden h-48 flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
                                    <img src={`/${item.imageUrl}`} alt={item.title} className="w-24 h-24 object-contain transform transition-transform duration-500 group-hover:scale-110" />
                                  </div>
                                  <div className="p-6 flex-grow flex flex-col">
                                    <h2 className="text-theme-blue text-lg font-semibold mb-3 group-hover:text-theme-purple transition-colors duration-300">{item.title}</h2>
                                    {item.description && (
                                      <p className="text-sm text-gray-600 font-light leading-relaxed flex-grow">{item.description}</p>
                                    )}
                                  </div>
                                </div>
                              </Button>
                            </Fade>
                          );
                        })
                    }
        </div>
      </div>
    </div>
  );
}
